import {
  OrganizationTaggingChangeArg,
  OrganizationTaggingChangeArgType
} from './organization-tagging-arg'

export interface TaggingArgs {
  readonly input?: OrganizationTaggingChangeArg
}

export const taggingArgs = {
  input: {
    type: OrganizationTaggingChangeArgType
  }
}
